import Vue from 'vue';
import FreielagerplaetzeService from './freielagerplaetze.service';

const getDefaultItem = () => ({});

const getDefaultState = () => ({
    item: getDefaultItem(),
    list: [],
});

const freielagerplaetze = {
    namespaced: true,

    state: Object.assign({}, getDefaultState()),

    mutations: {
        update(state, data) {
            Vue.set(state, 'item', data);
        },
        updateList(state, data) {
            Vue.set(state, 'list', data);
        },
        clear(state) {
            Vue.set(state, 'item', getDefaultState().item);
            Vue.set(state, 'list', getDefaultState().list);
        },
    },

    actions: {
        clear({ commit }) {
            commit('clear');
        },
        async create(context, client_data) {
            const { data } = await FreielagerplaetzeService.create(client_data);
            context.commit('update', data);
            return data;
        },
        async update(context, client_data) {
            const { data } = await FreielagerplaetzeService.update(client_data.id, client_data);
            context.commit('update', data);
            return data;
        },
        async get(context, id) {
            const { data } = await FreielagerplaetzeService.get(id);
            context.commit('update', data);
            return data;
        },
        async query(context, params) {
            const { data } = await FreielagerplaetzeService.query(params);
            context.commit('updateList', data);
            return data;
        },
        async delete(context, slug) {
            await FreielagerplaetzeService.delete(slug);
        },
    },

    getters: {
        data(state) {
            return state.item;
        },
        list(state) {
            return state.list;
        },
    },
};

export default freielagerplaetze;
